import Rest from '../../Rest'

export default class CebasCredentialingService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/cebas/credentialings/configs'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
